import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { IUpdateUserDTO } from '../model/types';
import updateUserApi from './client';

type UpdateUserVariables = {
  id: string;
  payload: IUpdateUserDTO;
};

export const useUpdateUser = (
  options?: UseMutationOptions<
    unknown,
    AxiosError<{ Error?: { message?: string } }>,
    UpdateUserVariables
  >
) => {
  return useMutation({
    mutationFn: ({ id, payload }) => updateUserApi.update(id, payload),
    ...options,
  });
};
